import React, { useState } from "react";
import "./Gallery.scss";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const videos = [
  "https://www.youtube.com/embed/4Dxr3fOcvAA?autoplay=1&mute=1",
  "https://www.youtube.com/embed/633DnuYTmj8?autoplay=1&mute=1",
  "https://www.youtube.com/embed/Ysa_ubpUEh0?autoplay=1&mute=1",
  "https://www.youtube.com/embed/-6BnlrAdnXg?autoplay=1&mute=1",
  "https://www.youtube.com/embed/yss4VOPlnps?autoplay=1&mute=1",
];

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % videos.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Gallery</h2>

      <div className="main-video-wrapper">
        <iframe
          key={activeIndex}
          src={videos[activeIndex]}
          title={`Video ${activeIndex + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="main-video"
        ></iframe>

        <div className="video-nav">
          <button className="nav-btn left" onClick={handlePrev}>
            <FaAngleLeft />
          </button>
          <button className="nav-btn right" onClick={handleNext}>
            <FaAngleRight />
          </button>
        </div>
      </div>

      <div className="thumbnail-wrapper">
        {videos.map((video, index) => {
          const thumbnail = `https://img.youtube.com/vi/${
            video.split("/embed/")[1].split("?")[0]
          }/0.jpg`;
          return (
            <img
              key={index}
              src={thumbnail}
              alt={`Video thumbnail ${index + 1}`}
              className={`thumbnail ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Gallery;
